<template>
  <div class="sharing-modal-wrapper">
    <div ref="sharingFolderModal" aria-hidden="true" class="modal fade hidden sharing-modal" role="dialog"
         tabindex='-1'>
      <div class="modal-dialog">
        <div class="modal-content" v-if="folder">
          <div class="modal-header">
            <h5 class="modal-title mt-0">
              <img src="../../assets/shareable-link.svg"/>
              <p v-if="isRevoke"> {{ $t('share_invite.revoke_sharing_title') }} <b>{{ folder.name }}</b></p>
              <p v-else>{{ $t('share_invite.edit_sharing_title') }} <b>{{ folder.name }}</b></p>
            </h5>
            <transition-expand>
              <a href="#" @click.prevent="sharingToggler(folder)" class="share-link">
                {{ folder.shared ? $t('share_invite.remove_shareable_link') : $t('share_invite.get_shareable_link') }}
              </a>
            </transition-expand>
          </div>
          <div class="modal-body">
            <div v-if="unverifiedUser" class="unverified-info">
              <p>
                {{ $t('verify.info_send_1') }} <strong> {{ $t('verify.info_send_2') }} </strong> {{
                $t('verify.info_share_3') }}
                <br>
                {{ $t('verify.info_part_2') }}
              </p>
            </div>
            <div class="new-sharing-options">
              <div v-if="folder.shared">
                <div class="shareable-link-wrapper">
                  <div class="sharing-link-group copy-to-clipboard-wrapper">
                    <label>
                      {{ $t('share_invite.link_sharing') }}
                    </label>
                    <input name="folder[shared_uuid]" type="text" class="public_link" readonly="true"
                           :value="sharedFolderUrl">
                    <p>{{ $t('share_invite.anyone_can_see') }}</p>
                    <a href='#' class="btn btn-neutral float-right"
                       @click.prevent="copyToClipboard($event, '.public_link')">
                      {{ $t('folders.settings.sharing_link_copy') }}
                    </a>
                  </div>
                  <div class="clearfix"></div>

                  <sharing-password
                      :folder_id="folder.id"
                      :has_password="folder.password_digest"
                      v-on:reload-settings="loadSettings(folder.id); reload()"/>

                  <sharing-expiration
                      :folder_id="folder.id"
                      :has_expiration="folder.sharing_expired_at != '' && folder.sharing_expired_at != null"
                      :expired_at="folder.sharing_expired_at"
                      :timezone="folder.timezone"
                      v-on:reload-settings="loadSettings(folder.id); reload()"/>
                </div>
              </div>
            </div>
            <transition-expand>
              <div v-if="!editMode">
                <sharing-with-contact ref="sharingWithContact"
                                      :folder="folder"
                                      v-on:edit-mode="editMode = true; loadShareInvites(folder.id); reload()"
                                      v-on:close-modal="closeModal"/>
              </div>
            </transition-expand>
            <transition-expand>
              <div v-if="editMode">
                <manage-sharing :folder-id="folder.id" v-on:edit-mode="editMode = false; loadSettings(folder.id)"
                                v-on:close-modal="closeModal" @success='reload' :comingFromMyShared="true"/>
              </div>
            </transition-expand>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SharingExpiration from './sharing_expiration'
import SharingPassword from './sharing_password'
import SharingWithContact from './sharing_with_contact'
import ManageSharing from './manage_sharing'
import TransitionExpand from '../shared/transition_expand'

export default {
  components: {
    'sharing-password': SharingPassword,
    'sharing-expiration': SharingExpiration,
    'sharing-with-contact': SharingWithContact,
    'transition-expand': TransitionExpand,
    'manage-sharing': ManageSharing,
  },
  props: {
    isRevoke: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      editMode: true,
      folder: null
    }
  },
  mounted() {
    $(this.$refs.sharingFolderModal).on('hidden.bs.modal', (e) => {
      this.$emit('modal-closed')
    })
  },
  computed: {
    sharedFolderUrl() {
      if (this.folder.shared_uuid)
        return window.location.origin + this.$router.resolve({
          name: 'public_shared_folder_show',
          params: {uuid: this.folder.shared_uuid}
        }).href
    },
  },
  methods: {
    reload() {
      this.$emit('success')
    },
    openModal: function (folder_id) {
      this.editMode = true

      $(this.$refs.sharingFolderModal).appendTo("body").modal('show')
      this.store.sendMetrics({name: 'my_shared_folders_edit_sharing', params: this.$route.params, path: this.$route.fullPath})

      this.loadSettings(folder_id)
      this.loadShareInvites(folder_id)
    },
    closeModal() {
      $(this.$refs.sharingFolderModal).modal('hide')
    },
    loadSettings(folder_id) {
      return this.axios.get('/folders/' + folder_id + '/settings').then(({data}) => {
        this.folder = data
      })
    },
    loadShareInvites(folder_id){
      this.store.getShareInvites(folder_id)
    },
    reloadFolderActivity(folder_id) {
      if (location.hash === "#activities")
        this.store.getFolderActivities(folder_id)
    },
    sharingToggler(folder) {
      let formData = new FormData()
      formData.append('folder[shared]', !folder.shared)
      this.axios.patch('/folders/' + folder.id + '/settings', formData)
          .then(response => {
            this.reload()
            this.loadSettings(folder.id)
            this.reloadFolderActivity(folder.id)
          })
    }
  }
}
</script>

<style lang="sass">
@import "../../styles/sharing_modal"

.sharing-modal
  .side-slide-leave-active, .side-slide-enter-active
    transition: 1s

  .side-slide-enter
    transform: translate(100%, 0)

  .side-slide-leave-to
    transform: translate(-100%, 0)

  .modal-title img
    margin-right: 10px
  h5
    p
      display: inline
</style>
